import React from "react";

const backend = [
    {
        name: 'Figma',
    },
    {
        name: 'UX Research Creativity',
    },
    {
        name: 'User Interface Prototyping',
    },
    {
        name: 'User Interface Design',
    },
    {
        name: 'User Experience (UX)',
    },
    {
        name: 'Usability Testing',
    }

]

const UiUx = () => {
    return (
        <div className='skills__content'>
            <h3 className='skills__title'>UI/UX Design</h3>

            <div className="skills__box">
                {backend.map((item, index) => (
                    <div className="skills__data" key={index}>
                        <i className='bx bx-badge-check'></i>
                        <div>
                            <h3 className="skills__name">
                                {item.name}
                            </h3>
                            <span className="skills__level">
                                {item.level}
                            </span>
                        </div>
                    </div>

                ))}
            </div>
        </div>
    )
}

export default UiUx;
